export const UNREAD_BADGE_CAP = 40;

/**
 * Display-only cap: the badge shows "40+" past the cap, the real count stays
 * in state/aria-label (screen readers and the notification-center inbox are
 * never truncated - only this label is).
 */
export const formatUnreadBadge = (count) =>
  count > UNREAD_BADGE_CAP ? `${UNREAD_BADGE_CAP}+` : `${count}`;
